import { useCallback } from "react"
import {
    getItemDetails as getItemDetailsUtil,
    getSkillLevelDetails as getSkillLevelDetailsUtil,
    getOtherDetails as getOtherDetailsUtil,
    getNotAllowedDetails as getNotAllowedDetailsUtil
} from "../utils/itemIconMapper"

/**
 * Custom hook to provide memoized item mapping functions
 */
export const useItemMapping = () => {
    const getItemDetails = useCallback((item) => {
        return getItemDetailsUtil(item)
    }, [])

    const getSkillLevelDetails = useCallback((item) => {
        return getSkillLevelDetailsUtil(item)
    }, [])

    const getOtherDetails = useCallback((item) => {
        return getOtherDetailsUtil(item)
    }, [])

    const getNotAllowedDetails = useCallback((item) => {
        return getNotAllowedDetailsUtil(item)
    }, [])

    return {
        getItemDetails,
        getSkillLevelDetails,
        getOtherDetails,
        getNotAllowedDetails
    }
}
